<ng-container *transloco="let t">
  <div
    [id]="'dynamic-message-banner-' + bannerId()"
    class="w-full border rounded-[24px] px-6 py-4 font-dm"
    [class]="styleConfig().bgClass + ' ' + styleConfig().borderClass"
    role="alert"
    [attr.aria-expanded]="expandable() ? isExpanded() : null"
  >
    <div
      class="flex items-center gap-4"
      [class.cursor-pointer]="expandable()"
      (click)="toggleExpanded()"
      (keydown.enter)="toggleExpanded()"
      (keydown.space)="toggleExpanded()"
      [attr.tabindex]="expandable() ? 0 : null"
      [attr.role]="expandable() ? 'button' : null"
      [attr.aria-label]="expandable() ? (isExpanded() ? 'Collapse message' : 'Expand message') : null"
    >
      <ld-svg-icon
        [id]="'dynamic-message-banner-icon-' + bannerId()"
        class="w-6 h-6 shrink-0"
        [src]="iconSrc()"
        aria-hidden="true"
      />

      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
      <div class="flex-1 min-w-0" (click)="onBannerClick($event)">
        <p
          [id]="'dynamic-message-banner-text-' + bannerId()"
          class="text-sm sm:text-base leading-6 m-0 text-ld-neutral-700"
          [class.truncate]="!isExpanded()"
        >
          @if (title()) {
            <span class="font-bold">{{ title() }}</span>
            @if (message()) {
              <span class="font-bold">–</span>
            }
          }
          <span [innerHTML]="message()"></span>
        </p>
      </div>

      @if (expandable()) {
        <button
          [id]="'dynamic-message-banner-toggle-' + bannerId()"
          type="button"
          class="shrink-0 w-6 h-6 flex items-center justify-center text-ld-neutral-500 hover:text-ld-neutral transition-transform duration-200 cursor-pointer"
          [class.rotate-180]="isExpanded()"
          aria-hidden="true"
          tabindex="-1"
        >
          <mat-icon class="w-6! h-6! text-[24px]!">expand_more</mat-icon>
        </button>
      } @else if (dismissible()) {
        <button
          [id]="'dynamic-message-banner-dismiss-' + bannerId()"
          type="button"
          class="shrink-0 w-6 h-6 flex items-center justify-center text-ld-neutral-500 hover:text-ld-neutral cursor-pointer"
          [attr.aria-label]="t('commonAriaDismissMessage')"
          (click)="onDismiss($event)"
        >
          <mat-icon class="w-6! h-6! text-[24px]!">close</mat-icon>
        </button>
      }
    </div>
  </div>
</ng-container>
